import layout from "../components/layout.vue";
// {
//   path: '/user',
//   component: UserLayout,
//   redirect: '/user/login',
//   hidden: true,
//   children: [
//     {
//       path: 'login',
//       name: 'login',
//       component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
//     },

//   ]
// },
export default [
  {
    path: "/user",
    component: layout,
    children: [
      {
        path: "/about",
        component: () => import("@/pages/about"),
      },
      {
        path: "/message",
        component: () => import("@/pages/message"),
      },
      {
        path: "/productp",
        component: () => import("@/pages/product.vue"),
      },
      {
        path: "/honerp",
        component: () => import("@/pages/honor.vue"),
      },
      {
        path: "/casep",
        component: () => import("@/pages/case.vue"),
      },
      {
        path: "/commonp",
        component: () => import("@/pages/products/common.vue"),
      },
      {
        path: "/proinfo",
        component: () => import("@/pages/products/info.vue"),
      },
    ],
  },

  {
    path: "/",
    name: "home",
    component: () => import("@/pages/homePage/index.vue"),
  },
];
